/**
 * Created by andreyna on 6/23/2016.
 */
import BaseModelComponent from '../../base/base_model_component';
import _ from '../../utils/underscore';
import * as EXTERNAL_LINKS_CONSTS from './external_links_consts';
import Device from '../../utils/device/device';
import ServiceFactory from '../../services/service_factory';
import {PRIORITY_LEVEL} from "../../services/overlay_manager/overlay_manager_levels";

/**
 *
 *
 *
 */
class ExternalLinksComponentModel extends BaseModelComponent {
    /**
     * @static
     * @type {string}
     */
    static CLASS = 'ExternalLinksModel';


    /**
     * @property
     * @type {Object}
     * @private
     */
    _handlersContext = require.context('./handlers/', true, /^.*(handler)\.js$/);


    /**
     *
     * @param params
     */
    init(params = {}) {
        this
            ._setForceHideCloseButton(params.forceHideCloseButton)
            ._setLinkConfig(params.linkConfig)
            ._setAddCloseOption(params.addCloseOption)
            ._setHandlersContext()
            ._setSource(params.source)
            ._setConfigKey(params.configKey)
            ._setView(params.view)
            ._setBackToView(params.backToView)
            ._setOptions(params.options)
            ._setNonAuthRequred()
            ._setForceAuth(params.forceAuth)
            ._setType(params.type)
            ._setSessionType(params.sessionType)
            ._setFrameLinkClass()
            ._setFrameName()
            ._setSourceLink(params.sourceLink)
            ._setActionCallback(params.actionCallback)
            ._setFrameScrolling(params.scrolling)
            ._setCallbackUrl(params.callbackUrl)
            ._setPriorityLevel(params.priorityLevel)
            ._initComponentId();

    }


    /**
     * Set link config
     * @param linkConfig
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setLinkConfig(linkConfig = EXTERNAL_LINKS_CONSTS.LINK_DEFAULT_CONGIF) {
        this._linkConfig = linkConfig;
        return this;
    }


    /**
     * Set require path to post message handlers
     *
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setHandlersContext() {
        this._handlers = this._handlersContext.keys().map(this._handlersContext);
        return this;
    }

    /**
     * Set source to external link.
     * If the source is GNWP template name, then source = about:blank to prevent GET request from iframe
     *
     * @param {string} source
     * @returns(ExternalLinksComponentModel)
     * @private
     */
    _setSource(source = '') {
        this.source = source;
        // this.sourceLink = source;
        if (ServiceFactory.create().gnwpService().isGNWPTemplate(source)) {
            // this.sourceLink = EXTERNAL_LINKS_CONSTS.GNWP_FRAME_NAME;
            this.configKey = source;
        } else {
            this.configKey = 'common_link';
        }

        return this;
    }


    /**
     * Override common_link configuration
     * @param configKey
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setConfigKey(configKey) {
        if (configKey && this.configKey === 'common_link') {
            this.configKey = configKey;
        }

        return this;
    }


    /**
     * Set source link
     *
     * @param sourceLink
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setSourceLink(sourceLink = '') {
        this.sourceLink = sourceLink;

        return this;
    }


    _setActionCallback(actionCallback) {
        this._actionCallback = actionCallback;
        return this;
    }


    /**
     * @param scrolling
     * @private
     */
    _setFrameScrolling(scrolling) {
        this.scrolling = scrolling || 'auto';
        return this;
    }


    /**
     * Callback url that should be used instead of GNWP process
     * @param url
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setCallbackUrl(url) {
        this._callbackUrl = url;
        return this;
    }


    /**
     * Set / override default priority level
     * @param priorityLevel
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setPriorityLevel(priorityLevel) {
        this._priorityLevel = priorityLevel || this._linkConfig[this.configKey].priorityLevel || PRIORITY_LEVEL.EXTERNAL_LINK;
        return this;
    }


    /**
     * Generate overlay id. This is should be used in ovelray that contains exteranl link frame
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _initComponentId() {
        this._componentID = this.frameName;
        return this;
    }


    /**
     * Define call type. Directive or API
     *
     * @param type
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setType(type = EXTERNAL_LINKS_CONSTS.COMPONENT_TYPES.DIRECTIVE) {
        this.type = type;

        return this;
    }


    /**
     * Define whether external link should not request GNWP is case user state doesn't match current auth state
     * If false parameter passed, then External links won't check auth state and execute GNWP request
     * The default is true, unless otherwise defined in configuration
     *
     * @param forceExecution
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setNonAuthRequred() {
        if (this._linkConfig[this.configKey]) {
            let isRequired = this._linkConfig[this.configKey].isNotAuthRequired;
            this.isNotAuthRequired = _.isBoolean(isRequired) ? isRequired : false;
        } else {
            this.isNotAuthRequired = false;
        }

        return this;
    }


    /**
     * Define whether force auth before loading external link.
     * If false parameter passed, then it override default behaviour.
     * The default is false, unless otherwise defined in configuration
     *
     * @param forceAuth
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setForceAuth(forceAuth) {
        if (this._linkConfig[this.configKey]) {
            let forceAuthValue = this._linkConfig[this.configKey].isAuthRequired;
            this.forceAuth = _.isBoolean(forceAuth) ? forceAuth : forceAuthValue;
        } else {
            this.forceAuth = false;
        }

        return this;
    }


    /**
     * Define new unique name to iframe
     *
     * @private
     */
    _setFrameName() {
        this.frameName = _.getGuid();

        return this;
    }

    /**
     * Define iframe css class to take appropriate dimensions
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setFrameLinkClass() {
        let config = this._linkConfig[this.configKey];
        if (config) {
            //cashier is the exception from the regular flow, because there are several difference cashier actions and in each one there is specified screen
            if (this.source === EXTERNAL_LINKS_CONSTS.GNWP_SOURCES.CASHIER && this.options && this.options.sessionType) {
                this.linkClass = config.dimensions.sessionType[this.options.sessionType];
            }
            this.linkClass = this.linkClass || config.dimensions.default || '';
        } else {
            this.linkClass = 'cgp-external-link-url';
        }

        return this;
    }


    /**
     * Set view target - define how to link should be opened (in new window or iframe)
     *
     * @param {string} view - 'iframe' or 'window'
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setView(view) {
        let viewValue = view;
        if (this._linkConfig[this.configKey]) {
            if (viewValue) {
                // check whether allowed target view value
                let allowedValues = this._linkConfig[this.configKey].allowedViews;
                if (!allowedValues.find(v => v === viewValue)) { // if is not allowed, set default
                    viewValue = this._getDefaultView('view');
                }
            } else { // if view is not provided - set default
                viewValue = this._getDefaultView('view');
            }
        } else if (!viewValue) { // default for not template source is iframe
            viewValue = EXTERNAL_LINKS_CONSTS.NAVIGATION_VIEWS.IFRAME;
        }
        this.view = viewValue;

        return this;
    }

    _setForceHideCloseButton(forceHideCloseButton) {
        this._forceHideCloseButton = forceHideCloseButton;

        return this;
    }

    /**
     * Set callback view target - define how to link with callback URL should be opened
     * @param backToView
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setBackToView(backToView) {
        let viewValue = backToView;
        if (viewValue) {
            let allowedValues = this._linkConfig[this.configKey].allowedViews;
            if (!allowedValues.find(v => v === viewValue)) { // if is not allowed, set default
                viewValue = this.view;
            }
        } else { // not provided -> get from config
            viewValue = this._getDefaultView('backToView');
            if (!viewValue) {
                viewValue = this.view;
            }
        }
        this.backToView = viewValue;

        return this;
    }

    getHandlers() {
        return this._handlers;
    }

    getForceHideCloseButton() {
        return this._forceHideCloseButton;
    }

    /**
     * Get default view appropriate to device type
     *
     * @returns {*}
     * @private
     */
    _getDefaultView(viewName) {
        let srcView = this._linkConfig[this.configKey][viewName];
        if (!srcView) {
            return null;
        }
        if (_.isString(srcView)) {
            return srcView;
        }
        let view;

        // get configuration for view per operation system
        if (srcView.os) {
            let os = Device.os.name;
            let deviceType = Device.isMobile() ? "mobile" : (Device.os.isPC ? "pc" : "");
            let viewConfig =
                srcView.os[os] &&
                srcView.os[os][deviceType];
            // if there is specified configuration for different browsers
            if (viewConfig && viewConfig.browsers) {
                let currentBrowser = Object.keys(viewConfig.browsers).find((browser) => {
                    let deviceBrowser = _.isFunction(Device.browser['is' + browser]) ? Device.browser['is' + browser] : false;
                    return deviceBrowser;
                });
                view = currentBrowser && viewConfig.browsers[currentBrowser] && viewConfig.browsers[currentBrowser].view;
            } else {
                view = viewConfig && viewConfig.view;
            }
            if (view) {
                return view;
            }
        }

        if (Device.hybrid.isHybrid && srcView.hybrid) {
            view = srcView.hybrid;
        } else {
            view = Device.isMobile() ? srcView.mobile : srcView.pc;
        }

        return view;
    }


    /**
     * Create options for open window view
     * @param windowOptions
     * @returns {*}
     * @private
     */
    _createWindowOptions(windowSize) {
        if (!windowSize) {
            return null;
        }
        // we assume that the size is defined as percentage of the full window size
        let height = Device.viewport.screenHeight * windowSize;
        let width = Device.viewport.screenWidth * windowSize;
        // top and left calculation is not used in this phase
            // let top = (Device.viewport.screenHeight - height) / 2;
            // let left = (Device.viewport.screenWidth - width) / 2;
        return `height=${height},width=${width}`;
    }


    /**
     *
     * @param integration
     * @returns {ExternalLinksComponentModel}
     * @private
     */
    _setOptions(options) {
        this.options = Object.assign({}, _.isObject(options) ? options : _.safeJSON(options, {}));

        return this;
    }


    /**
     * Set sessionType that defines on which page open cashier
     * @param sessionType
     * @private
     */
    _setSessionType(sessionType) {
        if (sessionType) {
            this.options.sessionType = sessionType;
        }

        return this;
    }


    /**
     * Set addCloseOption that defines if will be X close option with overlay
     * @param CloseOption
     * @private
     */
    _setAddCloseOption(addCloseOption = false) {
        this.addCloseOption = addCloseOption;

        return this;
    }

    /**
     * Get source to iframe
     *
     * @returns {string|*}
     */
    getSource() {
        return this.source;
    }

    /**
     * Get key to find configuration
     *
     * @returns {string|*}
     */
    getConfigKey() {
        return this.configKey;
    }


    /**
     * Get link configuration
     * @returns {{omg, my_account, cashier, membership, forgot_password, forgot_username, sport, poker, common_link, schedule_races, races_leaderBoard, races_widget, rich, pending_login}|*}
     */
    getLinkConfig() {
        return this._linkConfig;
    }


    /**
     * Get source link
     *
     * @returns {string|*|string}
     */
    getSourceLink() {
        return this.sourceLink;
    }


    /**
     * Get isForceAuth
     *
     * @returns {boolean|*}
     */
    getIsForceAuth() {
        return this.forceAuth;
    }


    /**
     * Get isNotAuthRequired
     *
     * @returns {boolean|*}
     */
    getIsNotAuthRequired() {
        return this.isNotAuthRequired;
    }


    /**
     * Get target where link should be opened
     *
     * @returns {string|*}
     */
    getTargetView() {
        return this.view;
    }


    /**
     * Get callback target view
     * @returns {*}
     */
    getCallbackView() {
        return this.backToView;
    }


    /**
     * Get call type
     *
     * @returns {string|*}
     */
    getType() {
        return this.type;
    }


    /**
     * Get additional options
     *
     * @returns {object} options
     */
    getOptions() {
        return this.options;
    }


    /**
     * Get unique iframe name used by controller
     *
     * @returns {string|*}
     */
    getFrameName() {
        return this.frameName;
    }


    /**
     * Get link class added to overlay in order to select specified external link iframe
     *
     * @returns {*|string|string|string|string|string}
     */
    getFrameLinkClass() {
        return this.linkClass;
    }


    getActionCallback() {
        return this._actionCallback;
    }


    /**
     * Get addCloseOption that defines if will be X close option with overlay
     */
    getAddCloseOption() {
        return this.addCloseOption;
    }

    /**
     * Get overlay ID used to open external link frame in
     * @returns {string|*}
     */
    getComponentId() {
        return this._componentID;
    }


    /**
     * Get overlay priority level
     * @returns {*}
     */
    getPriorityLevel() {
        return this._priorityLevel;
    }


    /**
     * Get window options to opening new window with specified parameters
     * @returns {null|*}
     */
    getWindowOptions() {
        return this._windowOptions;
    }


    /**
     * Callback url that should be used instead of GNWP process
     * @returns {*}
     */
    getCallbackUrl() {
        return this._callbackUrl;
    }
}

export default ExternalLinksComponentModel;